import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

const emptyPaginated = { data: [], total: 0 };

export function LocationsViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState(emptyPaginated);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const handleFailure = (callResult, title, fallback) => {
    if (callResult.errorStatus === 401) {
      logout();
      return;
    }
    showErrorModal(
      title,
      callResult.data?.message || callResult.data?.subtitle || fallback,
    );
  };

  const getLocations = async (search, page) => {
    setLoading(true);
    const callResult = await makePostApiCall("locations", {
      page,
      search: search ?? "",
    });
    setLoading(false);

    if (callResult.success) {
      setLocations(callResult.data);
      return;
    }

    handleFailure(callResult, "Could not load locations", "Please try again.");
  };

  const deleteLocation = async (location, onSuccess) => {
    setLoading(true);
    const callResult = await makePostApiCall(
      `deleteLocation/${location.id}`,
      {},
    );
    setLoading(false);

    if (callResult.success) {
      setEmptyModelOpen({ open: false, childComponent: null });
      getLocations("", 1);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data?.message || "Location deleted",
          SnackbarType.Success,
        ),
      );
      onSuccess?.();
      return true;
    }

    handleFailure(callResult, "Delete failed", "Could not delete location.");
    return false;
  };

  const askDeleteLocation = (location, onSuccess) => {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteLocation(location, onSuccess)}
          message={`Are you sure you want to delete ${location.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    loading,
    locations,
    getLocations,
    askDeleteLocation,
  };
}
